<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'POLITICAS.LBL_INFOPOLITICA' | translate }}" [selected]="tabSeleccionado === 'INFO'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fPoliticas" name="fPoliticas">
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <div class="grid form-group">
                  <div class="col-12 md:col-12 lg:col-12">
                    <div class="div-form">
                      <label>* {{ 'POLITICAS.LBL_CODIGO' | translate }}</label>
                      <div *ngIf="!politica">
                        <input type="text" pInputText id="codigo"
                               name="nomCodigo"
                               autocomplete="off"
                               formControlName="codigo"
                               maxlength="10"
                               (blur)="validarCodigo()"
                               codigos-reactive>
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                          {{ 'POLITICAS.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                        <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                          {{ 'POLITICAS.MSG_CODIGOEXISTE' | translate}}
                        </div>
                      </div>
                      <div *ngIf="politica && politica.idPoliticaCredito">
                        <label class="falso-combo-texto">{{politica.codigo}}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid form-group">
                  <div class="col-12 md:col-12 lg:col-12">
                    <div class="div-form">
                      <label>* {{ 'POLITICAS.LBL_NOMBRE' | translate }}</label>
                      <input type="text" pInputText id="nombre"
                             name="nomCodigo"
                             autocomplete="off"
                             formControlName="nombre"
                             maxlength="50"
                             capitalize-reactive>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                        {{ 'POLITICAS.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-8 lg:col-8">
                <div class="div-form">
                  <label for="descripcion">* {{ 'PERFILTERCERO.LBL_DESCPERFIL' | translate }}:</label>
                  <textarea id="descripcion" name="descripcion" pInputTextarea
                            capitalize-reactive rows="6" style="width: 100%" autocomplete="off"
                            formControlName="descripcion"
                            maxlength="500" required></textarea>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.descripcion.invalid">
                    <i class="fa fa-close"></i>
                    {{ 'PERFILTERCERO.LBL_DESCPERFIL' | translate }} {{'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <p-fieldset legend="* {{ 'POLITICAS.LBL_TIPO' | translate }}" class="col-12 md:col-4 lg:col-4 overflow-y-unset">
                <div class="div-form col-12 d-flex">
                  <div class="row col-12" style="display: flex">
                    <div class="col-12 md:col-6 lg:col-6">
                      <p-radioButton name="indicadorAlertaDescarta" [value]="true" inputId="indicadorDescarta"
                                     label="{{ 'POLITICAS.LBL_DESCARTA' | translate }}"
                                     formControlName="indicadorAlertaDescarta" (onClick)="alerta()"></p-radioButton>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <p-radioButton name="indicadorAlertaDescarta" [value]="false" inputId="indicadorAlerta"
                                     label="{{ 'POLITICAS.LBL_ALERTA' | translate }}"
                                     formControlName="indicadorAlertaDescarta" (onClick)="alerta()"></p-radioButton>
                    </div>
                  </div>
                  <div class="row col-12" style="display: flex">
                    <div class="grid form-group" *ngIf="f.indicadorAlertaDescarta.value === true">
                      <div class="col-12 md:col-6 lg:col-6">
                        <p-checkbox label="{{ 'POLITICAS.LBL_POROFICINA' | translate}}" binary="true"
                                    id="indicadorOficina"
                                    name="nomIndicador"
                                    formControlName="indicadorOficina"></p-checkbox>
                      </div>
                      <div class="col-12 md:col-6 lg:col-6">
                        <p-checkbox label="{{ 'POLITICAS.LBL_PORSEGMENTO' | translate}}" binary="true"
                                    id="indicadorSegmento"
                                    name="nomIndicador"
                                    formControlName="indicadorSegmento"></p-checkbox>
                      </div>
                      <div class="p-message p-messages-error p-corner-all"
                           *ngIf="submitted && aleRequerido">
                        {{ 'POLITICAS.LBL_REQUIEREALETADESCARTA' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="grid form-group" *ngIf="f.indicadorAlertaDescarta.value===false">
                    <div class="col-12 md:col-12 lg:col-12">
                      <p-checkbox label="{{ 'POLITICAS.LBL_REQAPROBACION' | translate}}" binary="true"
                                  id="indicadorReqAprobacion" (onChange)="cambiarRequiereAprobacion($event)"
                                  name="nomIndicadorRA"
                                  formControlName="indicadorRequiereAprobacion"></p-checkbox>
                      <br>
                      <div class="div-form" *ngIf="f.indicadorRequiereAprobacion.value">
                        <div class="row">
                          <div class="col-12">
                            <label>* {{ 'POLITICAS.LBL_NIVEL' | translate }}</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <p-dropdown disableTab  id="idNivel" name="nomNivel" [options]="listadoNiveles"
                                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                        formControlName="idNivel"
                                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                        optionValue="value"
                                        optionLabel="label"
                            ></p-dropdown>
                            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idNivel.invalid">
                              {{ 'POLITICAS.LBL_NIVEL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorAlertaDescarta.invalid">
                    {{ 'POLITICAS.LBL_REQUIEREALETADESCARTA' | translate}}
                  </div>
                </div>
              </p-fieldset>
              <div class="col-12 md:col-8 lg:col-8">
                <div class="div-form">
                  <label for="respuesta">* {{ 'POLITICAS.LBL_RESPUESTA' | translate }}:</label>
                  <textarea id="respuesta" name="respuesta" pInputTextarea
                            capitalize-reactive rows="6" style="width: 100%" autocomplete="off"
                            formControlName="respuesta"
                            maxlength="500" required></textarea>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.respuesta.invalid">
                    <i class="fa fa-close"></i>
                    {{ 'POLITICAS.LBL_RESPUESTA' | translate }} {{'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>


            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'POLITICAS.LBL_TITULAR' | translate}}" binary="true"
                            id="indicadorTitular"
                            name="nomIndicadorCambioEstado"
                            formControlName="indicadorTitular"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'POLITICAS.LBL_DEUDORSOL' | translate}}" binary="true"
                            id="indicadorDeudorSolidario"
                            name="indicadorDeudorSolidario"
                            formControlName="indicadorDeudorSolidario"></p-checkbox>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'POLITICAS.LBL_CODEUDOR' | translate}}" binary="true"
                            id="indicadorCodeudor"
                            name="indicadorCodeudor"
                            formControlName="indicadorCodeudor"></p-checkbox>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                            id="indicadorHabilitado"
                            name="indicadorHabilitado"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>

            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando" style="display: flex;justify-content: center">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-plus"
                          label="{{( politica && politica.idPoliticaCredito ? 'BTN_ACTUALIZAR' :'BTN_GUARDAR') | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="{{ 'POLITICAS.LBL_OFICINAS' | translate }}"
                        *ngIf="politica && politica.idPoliticaCredito && politica.indicadorDescarta && politica.indicadorOficina"
                        [selected]="tabSeleccionado === 'OFICINA'" [disabled]="!politica">
          <app-politicas-credito-oficinas (dismiss)="cambiarTabSeleccionado($event)" [politica]="politica"></app-politicas-credito-oficinas>
        </p-accordionTab>
        <p-accordionTab header="{{ 'POLITICAS.LBL_SEGMENTOS' | translate }}"
                        *ngIf="politica && politica.idPoliticaCredito && politica.indicadorDescarta && politica.indicadorSegmento"
                        [selected]="tabSeleccionado === 'SEGMENTO'" [disabled]="!politica">
          <app-politicas-credito-segmento (dismiss)="cambiarTabSeleccionado($event)" [politica]="politica"></app-politicas-credito-segmento>
        </p-accordionTab>
      </p-accordion>
      <div class="grid form-footer-buttons" *ngIf="politica && politica.idPoliticaCredito">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="politica-editar">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
